/* eslint-disable @typescript-eslint/no-explicit-any */
import { type ComponentType, lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { seoSettingsAdminAccessControl } from '../access-control/seoSettingsAdminAccess.configuration'

const SeoSettingsRobotsTxtPage = lazy(
  () =>
    import(
      /* webpackChunkName: "SeoSettingsRobotsTxtPage" */
      '../pages/robots-txt/SeoSettingsRobotsTxtPage'
    )
)

const SeoSettingsAdminWrapper = lazy(() =>
  import('../components/SeoSettingsAdminWrapper').then(m => ({
    default: m.SeoSettingsAdminWrapper,
  }))
)

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
//
// Admin (marketplace) surface: no retailer/site picker, so SeoSettingsAdminWrapper stands in for
// the partner route's SeoSettingsScopeWrapper purely to mount the HeaderTitlePortalTarget the
// page's HeaderPortal renders into. Registered in the domain's `admin` router bucket.
export const seoSettingsAdminRouter = (
  <DomainRoute route="app-admin-seo-settings" accessControl={seoSettingsAdminAccessControl}>
    <DashSwitch>
      <DomainRoute
        exact
        route="app-admin-seo-settings-robots-txt"
        component={SeoSettingsRobotsTxtPage as ComponentType<any>}
        scopePickerComponent={SeoSettingsAdminWrapper as ComponentType<any>}
      />
    </DashSwitch>
  </DomainRoute>
)
